import classNames from 'classnames';
import { Button } from 'components/atoms/Button';
import type { FC, ReactNode } from 'react';
import {
  FieldValues,
  UseFieldArrayReturn,
  useFormContext,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { formResetOptions } from 'utils/constants';
import { TrashIconOutline } from 'utils/icons';

type FieldsArrayProps = {
  name: string;
  render: (api: {
    field: Record<'id', string>;
    index: number;
    remove: (index: number) => void;
  }) => ReactNode;
  className?: string;
  // canRemoveLast?: boolean;
  controller: UseFieldArrayReturn<FieldValues, any, 'id'>;
  isItemsRemovable?: boolean;
  baseindex?: number;
  showItemsNumber?: boolean;
};

const FieldsArray: FC<FieldsArrayProps> = ({
  // name,
  render,
  className,
  // canRemoveLast,
  controller,
  isItemsRemovable = true,
  baseindex = 0,
  showItemsNumber = true,
}) => {
  const { t } = useTranslation();
  const { reset, getValues } = useFormContext();
  const { fields, remove } = controller;

  if (!fields.length) return null;

  // if (!canRemoveLast && fields.length === 1)
  //   return (
  //     <div key={fields[0].id} className={classNames(className)}>
  //       {render({ field: fields[0], index: 0 })}
  //     </div>
  //   );

  const _remove = (index: number) => {
    remove(index);
    reset(getValues(), formResetOptions);
  };

  return (
    <div className={classNames('flex flex-col gap-8', className)}>
      {fields.map((field, index) => (
        <div key={field.id}>
          {(isItemsRemovable || showItemsNumber) && (
            <div className="flex items-center justify-between mb-4">
              {showItemsNumber && (
                <p className="font-bold text-main-900 text-xl tracking-tight font-avenir">
                  {t('item', { number: baseindex + index + 1 })}
                </p>
              )}
              {isItemsRemovable && (
                <Button
                  onClick={() => _remove(index)}
                  structure="text"
                  color="primary"
                >
                  <TrashIconOutline className="w-5 text-primary-400" />
                </Button>
              )}
            </div>
          )}
          {render({ field, index, remove: _remove })}
        </div>
      ))}
    </div>
  );
};

export default FieldsArray;
